import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const NAV_LINKS = [
  { id: "studio",  label: "О нас",    section: "studio" },
  { id: "skills",  label: "Навыки",   section: "skills" },
  { id: "work",    label: "Работы",   section: "work" },
  { id: "method",  label: "Метод",    section: "method" },
  { id: "team",    label: "Команда",  section: "team" },
  { id: "clients", label: "Клиенты",  section: "clients" },
  { id: "contact", label: "Контакт",  section: null },  // footer, always visible
];

function IconVimeo() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
      <path d="M23.977 6.416c-.105 2.338-1.739 5.543-4.894 9.609-3.268 4.247-6.026 6.37-8.29 6.37-1.404 0-2.59-1.297-3.553-3.892l-1.945-7.137c-.722-2.593-1.494-3.89-2.318-3.89-.18 0-.81.378-1.893 1.126L0 7.139c1.2-1.053 2.38-2.108 3.547-3.16C5.087 2.69 6.24 1.93 7.005 1.86c1.81-.173 2.93 1.07 3.354 3.728.452 2.872.766 4.655.942 5.347.522 2.4 1.097 3.6 1.726 3.6.486 0 1.215-.77 2.187-2.312.969-1.541 1.485-2.713 1.548-3.515.123-1.182-.342-1.776-1.395-1.776-.495 0-1.005.115-1.531.341 1.022-3.355 2.972-4.985 5.852-4.892 2.135.063 3.14 1.45 3.014 4.135z"/>
    </svg>
  );
}
function IconBehance() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
      <path d="M22 7h-7v-2h7v2zm1.726 10c-.442 1.297-2.029 3-5.101 3-3.074 0-5.564-1.729-5.564-5.675 0-3.91 2.325-5.92 5.466-5.92 3.082 0 4.964 1.782 5.375 4.426.078.506.109 1.188.095 2.14h-8.027c.13 3.211 3.483 3.312 4.588 2.029h3.168zm-7.686-4h4.965c-.105-1.547-1.136-2.219-2.477-2.219-1.466 0-2.277.768-2.488 2.219zm-9.574 6.988h-6.466v-14.967h6.953c5.476.081 5.58 5.444 2.72 6.906 3.461 1.26 3.577 8.061-3.207 8.061zm-3.466-8.988h3.584c2.508 0 2.906-3-.312-3h-3.272v3zm3.391 3h-3.391v3.016h3.341c3.055 0 2.868-3.016.05-3.016z"/>
    </svg>
  );
}
function IconTelegram() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
      <path d="M22.05 2.55 1.86 10.45c-1.18.46-1.17 1.13-.22 1.42l5.18 1.62 11.99-7.57c.57-.34 1.09-.16.66.22L9.78 14.94l-.36 5.32c.47 0 .67-.21.93-.46l2.23-2.17 4.63 3.42c.85.47 1.46.23 1.67-.79l3.03-14.27c.31-1.25-.49-1.82-1.86-1.44z"/>
    </svg>
  );
}

const SOCIALS = [
  { key: "vimeo",    Icon: IconVimeo,    label: "Vimeo",    field: "social_vimeo" },
  { key: "behance",  Icon: IconBehance,  label: "Behance",  field: "social_behance" },
  { key: "telegram", Icon: IconTelegram, label: "Telegram", field: "social_telegram" },
];

export default function Navigation({ site = {}, onDiscussClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id) => {
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setOpen(false);
  };

  const goHome = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  const enabled = site.section_enabled || {};
  const links = NAV_LINKS.filter((l) => l.section === null || enabled[l.section] !== false);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-black/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="px-5 sm:px-8 lg:px-12 py-4 flex items-center justify-between gap-4">
       <button
  data-testid="nav-logo"
  onClick={goHome}
  className="flex items-center gap-3 group"
>
  <span className="w-2.5 h-2.5 rounded-full bg-[#a78bfa] bbf-pulse" />
  
  <div className="flex items-center gap-1.5 mr-4">
    <span className="font-display text-[13px] tracking-[0.18em] uppercase">
      Big&nbsp;Bag&nbsp;Films
    </span>
    
    {/* Добавили relative и -top-1 для легкого сдвига вверх */}
    <svg 
      viewBox="0 0 556 400" 
      className="opacity-90 relative -top-1"
      style={{ height: '16px', width: 'auto' }}
      fill="white"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M0,400V237.543c0-10.206,6.118-19.416,15.521-23.365l505.141-192.165c16.791-7.052,35.338,5.29,35.338,23.514V200.19c0,11.047-7.103,20.839-17.597,24.261L0,400z M192.537,237.722c14.519-10.061,14.04-21.089,13.705-30.134c-0.575-17.413-14.567-27.715-32.681-20.46l-66.898,26.809c-2.313,0.927-3.83,3.17-3.83,5.664v109.054l71.111-24.523c28.272-9.722,32.297-25.877,32.297-44.983C206.242,250.105,201.498,238.012,192.537,237.722L192.537,237.722z M172.507,257.553c6.134-2.225,11.932,2.225,11.932,9.48c0,8.078-5.798,14.753-11.932,16.978l-48.062,17.026v-25.829L172.507,257.553z M172.507,210.249c6.086-2.37,11.932,0.387,11.932,8.465c0,7.255-5.798,15.672-11.932,17.993l-48.062,18.09v-25.781L172.507,210.249z M357.042,240.963l18.345-6.265c2.412-0.824,4.033-3.092,4.033-5.643v-47.538l53.854-19.759c2.336-0.857,3.888-3.082,3.888-5.572v-10.825c0-4.149-4.146-7.016-8.023-5.548l-49.719,18.825v-29.118l69.51-27.12c2.266-0.884,3.758-3.069,3.758-5.503V83.899c0-4.187-4.227-7.049-8.11-5.492L360.76,112.02c-2.246,0.901-3.718,3.079-3.718,5.5V240.963z M321.87,189.74c15.382-10.641,14.807-22.25,14.519-31.827c-0.671-18.38-15.574-29.892-34.693-22.201l-70.846,28.54c-2.245,0.904-3.715,3.083-3.715,5.505v116.043l75.136-25.926c29.853-10.254,34.118-26.458,34.118-46.628C336.389,203.671,331.357,190.03,321.87,189.74L321.87,189.74z M300.689,210.539c6.517-2.37,12.651,2.515,12.651,10.158c0,8.513-6.134,15.526-12.651,17.8l-50.746,17.993v-27.377L300.689,210.539z M300.689,160.235c6.421-2.515,12.651,0.822,12.651,9.335c0,7.642-6.182,16.3-12.651,18.719l-50.746,19.154v-27.425L300.689,160.235z" />
    </svg>
  </div>
</button>

        <nav className="hidden lg:flex items-center gap-8 xl:gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => goTo(l.id)}
              className="bbf-link text-[12px] tracking-[0.22em] uppercase text-white/80 hover:text-white"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <div className="flex items-center gap-3 mr-1">
            {SOCIALS.map(({ key, Icon, label, field }) => (
              <a
                key={key}
                data-testid={`nav-social-${key}`}
                href={site[field] || "#"}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                className="text-white/55 hover:text-white transition-colors"
              >
                <Icon />
              </a>
            ))}
          </div>
          <button
            data-testid="nav-discuss-button"
            onClick={onDiscussClick}
            className="bbf-btn-primary px-5 py-2.5 uppercase text-[11px] tracking-[0.22em] font-bold"
          >
            {site.discuss_button || "Обсудить проект"}
          </button>
        </div>

        <button
          data-testid="nav-burger"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden flex flex-col gap-[5px] p-2"
          aria-label="Toggle menu"
        >
          <span className={`block h-[1.5px] w-6 bg-white transition-transform ${open ? "translate-y-[7px] rotate-45" : ""}`} />
          <span className={`block h-[1.5px] w-6 bg-white transition-opacity ${open ? "opacity-0" : ""}`} />
          <span className={`block h-[1.5px] w-6 bg-white transition-transform ${open ? "-translate-y-[7px] -rotate-45" : ""}`} />
        </button>
      </div>

      <div
        data-testid="nav-mobile-menu"
        className={`lg:hidden overflow-hidden transition-[max-height,opacity] duration-500 bg-black/95 backdrop-blur-xl ${
          open ? "max-h-[640px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-6 py-8 flex flex-col gap-5 border-t border-white/10">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => goTo(l.id)}
              data-testid={`nav-mobile-${l.id}`}
              className="text-left font-display text-2xl uppercase tracking-tight"
            >
              {l.label}
            </button>
          ))}
          <div className="flex items-center gap-5 mt-2">
            {SOCIALS.map(({ key, Icon, label, field }) => (
              <a
                key={key}
                href={site[field] || "#"}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                className="text-white/65 hover:text-white"
              >
                <Icon />
              </a>
            ))}
          </div>
          <button
            onClick={() => { setOpen(false); onDiscussClick && onDiscussClick(); }}
            data-testid="nav-mobile-discuss"
            className="mt-3 self-start bbf-btn-primary px-6 py-3 uppercase text-[11px] tracking-[0.22em] font-bold"
          >
            {site.discuss_button || "Обсудить проект"}
          </button>
        </div>
      </div>
    </header>
  );
}